import React, { useState } from 'react';
import "./Projects.css"
import imagie from '../../assets/project10.png'
import profile from '../../assets/web1.png'
import ai from '../../assets/robot.png'
import chat from '../../assets/solana.png'
import parallax from '../../assets/parallax.png'
import backend from '../../assets/backend.png'
import backend2 from '../../assets/backend2.png'
import backend3 from '../../assets/backend3.png'
import mern from '../../assets/mern.png'
import mern2 from '../../assets/mern2.png'
import '../../components/Card.css'
import { FaEye } from 'react-icons/fa'
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useEffect } from 'react';
import Underdev from './Underdev';


function Projects() {

  const { ref, inView } = useInView({
    threshold: 0.1, // Trigger animation when the component is at least 50% visible
    triggerOnce: false // Trigger animation every time the component comes into view
  });

  // Use `useAnimation` to trigger the animation
  const animation = useAnimation();

  // Define the animation
  const leftVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 } }
  };
  const topVariants = {
    hidden: { opacity: 0, y: -30 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 } }
  };

  

  // Use `useEffect` to trigger the animation when the component comes into view
  useEffect(() => {
    if (inView) {
      animation.start('visible');
    } else {
      animation.start('hidden');
    }
  }, [inView]);

  
  const [ show , setShow ] = useState(false);

  const handleShow = () => {
    if(!show) {
      setShow(true)
    }
  }

  const handleClose = () => {
    setShow(false)
  }
















  const [selectedType, setSelectedType] = useState('Frontend');
  const [selectedWebsite, setSelectedWebsite] = useState(null);



  const websites = [
    {
      id: 1,
      name: 'Portfolio',
      type: 'Frontend',
      description: 'This is portfolio website.which is developed using language Reactjs.This website has many new interesting features inside.Like "Theme changing"',
      image:  profile ,
      link : "https://pranav-web.vercel.app/"
    },
    {
      id: 2,
      name: 'AI image',
      type: 'Frontend',
      description: ' Explore the Possibilities of AI Chatting . This website has many new interesting features . The unique UI design with black theme',
      image: ai,
      link: "https://robo-ai.netlify.app/"
    },
    {
      id: 3,
      name: 'Solana dapp',
      type: 'Frontend',
      description: 'This is Solana Dapp . build to connect and manage your wallet transaction and Balance . P2P transaction Available with secure blockchain',
      image: chat,
      link: 'https://solana-dapp-wallet.vercel.app/'
    },
    {
      id: 5,
      name: 'backend App 1',
      type: 'Fullstack',
      description: 'This is Fullstack school management app . where we can update student fee management system  and student details ',
      image: backend,
      link: 'https://schoolsweb.netlify.app/'
    },
    {
      id: 6,
      name: 'Backend App 2',
      type: 'Fullstack',
      description: 'This is Backend app 2 A computer program is a sequence or set of instructions in a programming language for a computer to execute',
      image: backend2
    },
    {
      id: 7,
      name: 'Backend App 3',
      type: 'Fullstack',
      description: 'This is Backend app 2 A computer program is a sequence or set of instructions in a programming language for a computer to execute',
      image: backend3
    },
    
  ];

  function handleTypeClick(type) {
    setSelectedType(type);
  }









  function filterWebsitesByType(type) {
    return websites.filter((website) => website.type === type);
  }

  const types = Array.from(new Set(websites.map((website) => website.type)));


 


  return (
    <div className='portfolio__container' ref={ref} >
      <motion.div variants={topVariants} 
          initial="hidden"
          animate={animation} >
      {types.map((type) => (
        <button key={type} onClick={() => handleTypeClick(type)} className={`button_1 ${selectedType === type ? 'active' : ''}`}>
          {type}
        </button>
      ))}
      </motion.div>

      <motion.div className='card-1' variants={leftVariants} 
          initial="hidden"
          animate={animation}>
        {filterWebsitesByType(selectedType).map((website) => (
          <div className="projects__card" key={website.id}>
            <img src={website.image}  className = "project__image"/>
            <h4>{website.name}</h4>
            <p>{website.description}</p>
            <a href={website.link} target="_blank" rel="noopener noreferrer"><button className='button_1' >View <FaEye className='faeye'/></button></a>
            <button className='button_2'><a href={website.link}>github </a></button>
          </div>
        ))}
      </motion.div>
      {
        show ? 
        <Underdev   handleClose = {handleClose} />
        : ''
      }
    </div>
  );
}

export default Projects;
